<template>
  <ten-picker
    v-bind="$attrs"
    type="time"
    :value="value"
    :is-range="isRange"
    v-on="$listeners"
  >
    <template #default="{ time, onChangeHandler, getRelatedInput, format }">
      <component
        :is="isRange ? 'TenTimeRange' : 'TenTime'"
        :value="time"
        :format="format"
        :get-related-input="getRelatedInput"
        :disabled-hour="disabledHour"
        :disabled-min="disabledMin"
        :disabled-sec="disabledSec"
        @change="onChangeHandler"
      />
    </template>

    <template #suffxIcon>
      <!-- @slot @ignore -->
      <slot name="suffixIcon" />
    </template>

    <template #clearIcon>
      <!-- @slot @ignore -->
      <slot name="clearIcon" />
    </template>
  </ten-picker>
</template>

<script>
import TenPicker from '../date-picker/picker';
import TenTime from '../date-picker/panel/time';
import TenTimeRange from '../date-picker/panel/time-range';

const name = 'ten-time-picker';

export default {
  name,
  components: {
    TenPicker,
    TenTime,
    TenTimeRange,
  },
  provide() {
    return {
      wrapper: this,
    };
  },
  model: {
    value: 'value',
    event: 'change',
  },
  props: {
    /**
     * @ignore
     */
    value: { type: [Date, String, Array] },
    /**
     * @ignore
     */
    isRange: Boolean,
    /**
     * 禁用小时，函数参数为 hour，当返回false时，该小时被禁选
     */
    disabledHour: { type: Function, default: () => false },
    /**
     * 禁用分钟，函数参数为 (hour, minute)，当返回false时，该分钟被禁选
     */
    disabledMin: { type: Function, default: () => false },
    /**
     * 禁用秒，函数参数为 (hour, minute, second)，当返回false时，该秒被禁选
     */
    disabledSec: { type: Function, default: () => false },
  },
};
</script>
